import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Tap, Pay, Perform - FeeZaap!</h1>
            <p className="hero-subtitle">
              The ultimate digital fee management platform for dance schools. Streamline payments, manage batches, and reward parents with our secure, DPDP Act 2023 compliant solution.
            </p>
            <div className="hero-buttons">
              <a href="https://play.google.com/store" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-google-play"></i> Play Store
              </a>
              <a href="https://apps.apple.com" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-app-store-ios"></i> App Store
              </a>
            </div>
          </div>

          <div className="hero-stats">
            <div className="stat">
              <h3>500</h3>
              <p>Dance Schools</p>
            </div>
            <div className="stat">
              <h3>10,000</h3>
              <p>Parents</p>
            </div>
            <div className="stat">
              <h3>50L</h3>
              <p>Processed</p>
            </div>
          </div>
        </div>

        <div className="hero-image">
          <div className="app-showcase">
            <img
              src="/assets/images/splash-screen.jpg"
              alt="FeeZaap App Splash Screen - Welcome Interface"
              className="app-screen splash"
            />
            <img
              src="/assets/images/login-screen.jpg"
              alt="FeeZaap Parent Login Screen - Secure Authentication"
              className="app-screen login"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
